import SliceNames from '@/state/enum';
import getBrand from '@/state/selectors/brand/get-brand';
import { BrandActions, BrandState } from '@/state/slices/brand/typings';
import { IStore, SetState } from '@/state/slices/typings';

const brandActionsCreator = (
	set: SetState<IStore>,
	get: () => IStore,
): BrandActions => {
	return {
		[SliceNames.BRAND]: {
			setBrand: (brand: BrandState[SliceNames.BRAND]['brand']) => {
				const currentBrand = getBrand(get());
				if (currentBrand === brand) return;
				set(
					(state) => ({
						...state,
						[SliceNames.BRAND]: {
							...state[SliceNames.BRAND],
							brand,
						},
					}),
					undefined,
					{ type: `${SliceNames.BRAND}/setBrand`, brand },
				);
			},
		},
	};
};

export default brandActionsCreator;
